<div class="loading-indicator" *ngIf="showLoadingSpinner">
    <logo-mark isSpinning="true"></logo-mark>
</div>

<router-outlet></router-outlet>